export default [
    {
        path: 'relatorio-quantitativo-producao',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-producao' */
            '@/views/ambulatorio/relatorio-quantitativo-producao/Index'
        ),
        redirect: 'relatorio-quantitativo-producao/index',
        children: [
            {
                name: 'ambulatorio-relatorio-quantitativo-producao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-producao' */
                    '@/views/ambulatorio/relatorio-quantitativo-producao/List.vue'
                ),
            },
        ],
    },
]